import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { TopMenu, SideMenu } from "./components";
import ZendeskTopMenu from "./components/ZendeskTopMenu/ZendeskTopMenu.component";
import DevModeWarning from "../DevModeWarning/DevModeWarning.component";
import { isDevAutoLoginEnabled, DEV_MODE_WARNING_DISMISS_KEY, DEV_BANNER_HEIGHT } from "../../config/devAuth";

const Layout = ({ zendeskView, children }) => {
  const [sideBarVisible, setSideBarVisible] = useState(false);
  const [sideMenuExtended, setSideMenuExtended] = useState(true);
  const [bannerVisible, setBannerVisible] = useState(() => {
    return isDevAutoLoginEnabled() && localStorage.getItem(DEV_MODE_WARNING_DISMISS_KEY) !== "true";
  });

  useEffect(() => {
    if (bannerVisible) {
      document.documentElement.style.setProperty('--dev-banner-height', DEV_BANNER_HEIGHT);
    } else {
      document.documentElement.style.setProperty('--dev-banner-height', '0px');
    }
    return () => {
      document.documentElement.style.setProperty('--dev-banner-height', '0px');
    };
  }, [bannerVisible]);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === DEV_MODE_WARNING_DISMISS_KEY) {
        setBannerVisible(isDevAutoLoginEnabled() && e.newValue !== "true");
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  const handleBannerDismiss = () => {
    setBannerVisible(false);
  };

  return zendeskView ? (
    <>
      <DevModeWarning visible={bannerVisible} onDismiss={handleBannerDismiss} />
      <ZendeskTopMenu />
      <div
        className="main-container__content"
        style={{ paddingTop: "calc(var(--dev-banner-height) + var(--top-menu-height) + var(--announcement-banner-height) + 1em)" }}
      >
        {children}
      </div>
    </>
  ) : (
    <>
      <DevModeWarning visible={bannerVisible} onDismiss={handleBannerDismiss} />
      <TopMenu
        setSideMenuExtended={setSideMenuExtended}
        setSideBarVisible={setSideBarVisible}
      />
      <SideMenu
        visible={sideBarVisible}
        setVisible={setSideBarVisible}
        extended={sideMenuExtended}
        setExtended={setSideMenuExtended}
      >
        {children}
      </SideMenu>
    </>
  );
};

Layout.propTypes = {
  zendeskView: PropTypes.bool,
  children: PropTypes.node
};

export default Layout;
